import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import type { Client } from '~/models'

export default function LogoOverlay({ client }: { client: Client }) {
  const location = useLocation()
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true)
    }, 750)
  }, [])

  if (location.pathname !== '/' || isLoaded) {
    return null
  }

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
        <span className="w-64 pb-32">
          {client.logo ? <img src={client.logo} /> : <img src="/logo.svg" />}
        </span>

        {client.logo && (
          <div className="fixed bottom-4 right-4 w-32">
            <img alt="Logo" src="/logo.svg" />
          </div>
        )}
      </div>
    </>
  )
}
